import clsx from 'clsx'
import type { ComponentProps, ReactNode } from 'react'
import type { UiIconName } from '#lib/ui/icon/icon'
import { Icon } from '#lib/ui/icon/icon'
import {
  type InputIconPositionVariant,
  type InputInputStaticWidthVariant,
  type InputVariants,
  inputStyles as styles,
} from './input.css'
import { inputRootStyles } from './input-root.css'

interface Props
  extends Omit<ComponentProps<'input'>, 'prefix' | 'size'>,
    InputVariants {
  error?: ReactNode | boolean
  prefix?: ReactNode
  icon?: UiIconName
  iconPosition?: InputIconPositionVariant
  fullWidth?: boolean
  staticWidth?: InputInputStaticWidthVariant
}

export function Input({
  variant,
  size,
  error,
  prefix,
  icon,
  iconPosition = 'right',
  fullWidth,
  staticWidth,
  className,
  style,
  ...props
}: Props) {
  const hasErrorMessage =
    typeof error !== 'boolean' && typeof error !== 'undefined' && error !== ''

  return (
    <>
      <div
        className={clsx(styles.inputWrapper({ variant, size }), className)}
        style={style}
        data-full-width={Boolean(fullWidth)}
        data-valid={!error}
      >
        {icon && iconPosition === 'left' && (
          <Icon
            icon={icon}
            size="md"
            className={styles.icon({ position: iconPosition })}
          />
        )}

        {prefix && <div className={styles.prefix}>{prefix}</div>}

        <input {...props} className={styles.input({ staticWidth })} />

        {icon && iconPosition === 'right' && (
          <Icon
            icon={icon}
            size="md"
            className={styles.icon({ position: iconPosition })}
          />
        )}
      </div>

      {hasErrorMessage && (
        <span className={inputRootStyles.errorMessage}>{error}</span>
      )}
    </>
  )
}
